import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Check, Lock } from "lucide-react";

export default function Pricing() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(null);
  const { user } = useAuth();
  const nav = useNavigate();

  useEffect(() => { api.get("/plans").then((r) => setPlans(r.data)); }, []);

  const subscribe = async (planId) => {
    if (!user) { toast.error("Accedi per abbonarti"); return nav("/accedi"); }
    setLoading(planId);
    try {
      const r = await api.post("/checkout/session", { plan_id: planId, origin_url: window.location.origin });
      window.location.href = r.data.url;
    } catch (e) {
      toast.error("Errore nell'avvio del pagamento");
      setLoading(null);
    }
  };

  return (
    <div>
      <section className="bg-navy py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-serif text-4xl sm:text-5xl font-bold text-white">Scegli il tuo abbonamento</h1>
          <p className="text-slate-300 mt-4 max-w-2xl mx-auto text-lg">Accedi a tutti i contenuti premium e resta sempre aggiornato sulle novità del diritto del lavoro.</p>
          {user?.is_subscribed && <div className="mt-6 inline-block bg-emerald/20 text-emerald border border-emerald/30 rounded-full px-5 py-2 text-sm font-medium">✓ Abbonamento attivo</div>}
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-3 gap-8">
        {plans.map((p) => {
          const highlight = !!p.highlight;
          return (
            <div key={p.id} data-testid={`plan-${p.id}`} className={`relative rounded-2xl p-8 border transition-all ${highlight ? "bg-navy text-white border-navy shadow-2xl md:-translate-y-4" : "bg-white border-slate-200 shadow-[0_8px_30px_rgb(0,0,0,0.04)]"}`}>
              {highlight && <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gold text-navy text-xs font-bold px-4 py-1 rounded-full">PIÙ SCELTO</span>}
              <h3 className={`font-serif text-2xl font-bold ${highlight ? "text-white" : "text-navy"}`}>{p.name}</h3>
              <div className="mt-4 mb-6">
                <span className={`font-serif text-5xl font-bold ${highlight ? "text-gold" : "text-navy"}`}>€{Number(p.amount).toFixed(2)}</span>
                <span className={highlight ? "text-slate-300" : "text-slate-400"}> /{p.period}</span>
              </div>
              <ul className="space-y-3 mb-8">
                {(p.features || []).map((f, fi) => (
                  <li key={fi} className={`flex items-start gap-2.5 text-sm ${highlight ? "text-slate-200" : "text-slate-600"}`}>
                    <Check className={`w-5 h-5 shrink-0 ${highlight ? "text-gold" : "text-emerald"}`} /> {f}
                  </li>
                ))}
              </ul>
              <button onClick={() => subscribe(p.id)} disabled={loading === p.id} data-testid={`subscribe-${p.id}`}
                className={`w-full rounded-full py-3.5 font-semibold transition-all ${highlight ? "bg-gold text-navy hover:bg-white" : "bg-navy text-white hover:bg-petrol"} disabled:opacity-60`}>
                {loading === p.id ? "Reindirizzamento..." : "Abbonati ora"}
              </button>
            </div>
          );
        })}
      </div>

      <div className="max-w-3xl mx-auto px-4 pb-16 text-center text-sm text-slate-400 flex items-center justify-center gap-2">
        <Lock className="w-4 h-4" /> Pagamenti sicuri con Stripe. Conforme al GDPR.
      </div>
    </div>
  );
}
